import { type ReactNode } from 'react';
import { cn } from './cn.ts';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

export function Card({ children, className, padding = 'md' }: CardProps) {
  const paddings = {
    none: '',
    sm: 'p-4',
    md: 'p-5',
    lg: 'p-6',
  };
  return (
    <div
      className={cn(
        'bg-white border border-zinc-200 rounded-xl',
        paddings[padding],
        className,
      )}
    >
      {children}
    </div>
  );
}

interface StatCardProps {
  label: string;
  value: ReactNode;
  sub?: string;
  icon?: ReactNode;
  trend?: { value: number; label: string };
}

export function StatCard({ label, value, sub, icon, trend }: StatCardProps) {
  return (
    <Card className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <p className="text-xs font-medium text-zinc-500 uppercase tracking-wide">{label}</p>
        <p className="mt-1.5 text-2xl font-semibold text-zinc-900 tabular-nums">{value}</p>
        {sub && <p className="mt-0.5 text-xs text-zinc-400">{sub}</p>}
        {trend && (
          <p className={cn('mt-1 text-xs font-medium', trend.value >= 0 ? 'text-emerald-600' : 'text-red-500')}>
            {trend.value >= 0 ? '+' : ''}{trend.value}% {trend.label}
          </p>
        )}
      </div>
      {icon && (
        <div className="flex-shrink-0 p-2 bg-zinc-50 rounded-lg text-zinc-400">
          {icon}
        </div>
      )}
    </Card>
  );
}
